import { useApi } from '@gravitate-js/the-armory'
import { useMutation, useQuery } from '@tanstack/react-query'
import { getAPIURL } from '@utils/api'

export const useTankStrategy = () => {
  const api = useApi({ baseURLOverride: getAPIURL() })

  const useTankStrategyOverviewQuery = (filter) =>
    useQuery({
      queryKey: ['tankStrategyOverview', filter],
      queryFn: ({ queryKey }) =>
        api.post('tank_strategy/overview', {
          filter: { ...queryKey[1], store_number: queryKey[1]?.store_number?.toString() },
        }),
      refetchOnWindowFocus: false,
    })

  return { useTankStrategyOverviewQuery }
}
